function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34 22.6734V25.9934L31.66 28.3334H28.34L26 25.9934V22.6734L28.34 20.3334H31.66L34 22.6734ZM32.82 10.3334H27.18L16 21.5134V27.1534L27.18 38.3334H32.82L44 27.1534V21.5134L32.82 10.3334ZM30 35.5134L18.82 24.3334L30 13.1534L41.18 24.3334L30 35.5134ZM19.06 34.4534L18 35.5134L6.82 24.3334L18 13.1534L19.06 14.2134L21.88 11.3934L20.82 10.3334H15.18L4 21.5134V27.1534L15.18 38.3334H20.82L21.88 37.2734L19.06 34.4534Z",
  fill: "black"
});

var SvgIconUsers = function SvgIconUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_users.fa8e4cb0.svg";
export { ForwardRef as ReactComponent };